<ng-container *ngIf="show">
    <mat-progress-bar
        [mode]="mode"
        [value]="progress"
        class="green-progress"
        >
    
    </mat-progress-bar>
</ng-container>
